const getters={
  routers:state=>state.routers.mapRouter,
  listFirstMenu: state=>state.login.listFirstMenu
}
export default  getters



// WEBPACK FOOTER //
// ./src/store/getters.js